export default {"src":"/_next/static/media/instamatch_prize_background_ribbon.ab236cca.svg","height":33,"width":42,"blurWidth":0,"blurHeight":0};